export const permissionsSettings = [
  "settings",
  "everything-full",
  "everything-readonly",
];
